import React from "react";
import { useTranslation } from "react-i18next";

function InnerTitle({ title, value, onChange, onNearByClick, isNearbyActive, onClearNearby }) {
  const { t } = useTranslation();
  return (
    <section className="search-head-section bg-primary-400 py-8 md:py-12 lg:py-16">
      <div className="container">
        <div className="search-head-content">
          <h1 className="heading-web-h3 text-white text-center mb-4">
            {title}
          </h1>

          <div className="search-box relative max-w-[655px] mx-auto flex gap-2">
            <div className="relative w-full">
              <input
                type="text"
                value={value}                // ✅ controlled
                onChange={onChange}          // ✅ controlled
                className="form-control-custom !pr-[50px]"
                placeholder={t("common.search_placeholder")}
              />

              <button
                type="button"
                className="absolute top-[8px] right-[15px]"
              >
                <img src="/images/search.svg" alt="search" />
              </button>
            </div>
            {onNearByClick && (
              <button
                type="button"
                onClick={isNearbyActive && onClearNearby ? onClearNearby : onNearByClick}
                className={`${
                  isNearbyActive
                    ? "bg-emerald-600 border border-emerald-700 text-white hover:bg-emerald-700"
                    : "bg-[#ffffff] border border-[#000000] text-[#000000] hover:brightness-105"
                } px-4 py-2 rounded-xl font-bold flex items-center gap-2 whitespace-nowrap transition-all shadow-sm active:scale-95`}
                title={isNearbyActive ? t("search.clear_nearby", "Click to clear nearby filter") : t("search.find_nearby", "Find Nearby")}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>
                {isNearbyActive ? t("search.nearby_active", "Nearby (ON)") : t("search.find_nearby", "Find Nearby")}
                {isNearbyActive && (
                  <span className="ml-1 bg-white/20 rounded-full p-0.5 hover:bg-white/30 text-xs">✕</span>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default InnerTitle;